// extracted by mini-css-extract-plugin
module.exports = {"story":"story--C1jwz","stretch":"stretch--jLDyh","loader":"loader--P8LxB"};